import React from 'react';
import Game2048 from '../components/Game2048';
import styles from './Game2048Page.module.css';

const Game2048Page: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>2048</h1>
      <div className={styles.gameContainer}>
        <Game2048 />
      </div>
    </div>
  );
};

export default Game2048Page; 